import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  logoFacebook,
  logoInstagram,
  logoTiktok,
  logoX,
  logoYoutube,
} from 'ionicons/icons';

@Component({
  selector: 'app-menu-social',
  templateUrl: './menu-social.component.html',
  styleUrls: ['./menu-social.component.scss'],
  standalone: true,
  imports: [CommonModule, IonIcon],
})
export class MenuSocialComponent {
  constructor() {
    addIcons({
      logoFacebook,
      logoInstagram,
      logoTiktok,
      logoX,
      logoYoutube,
    });
  }
}
